module.exports = __webpack_public_path__ + "static/img/1200x100.57707f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1200x100.png
// module id = WFps
// module chunks = 8